<template>
	<div class="provider-layout">
		<provider-header></provider-header>
		<div class="provider-body">
			<aside class="provider-sidebar">
				<div class="sidebar-heading">
					<span class="heading-mark"><i class="el-icon-s-grid"></i></span>
					<div>
						<strong>服务商中心</strong>
						<small>Provider Center</small>
					</div>
				</div>
				<el-menu :default-active="activeMenu" router class="provider-menu">
					<el-menu-item v-for="item in visibleMenus" :key="item.path" :index="item.path">
						<svg-icon :icon-class="item.icon"></svg-icon>
						<span>{{ item.title }}</span>
					</el-menu-item>
				</el-menu>
			</aside>

			<main class="provider-main">
				<router-view></router-view>
			</main>
		</div>
	</div>
</template>

<script>
	import { mapGetters } from 'vuex'
	import ProviderHeader from '@/components/ProviderHeader'

	export default {
		name: 'ProviderLayout',
		components: { ProviderHeader },
		data() {
			return {
				menus: [
					{ title: '个人资料', path: '/provider/profile', icon: 'user' },
					{ title: '商家申请', path: '/provider/application', icon: 'apply' },
					{ title: '我的店铺', path: '/provider/store', icon: 'enterprise' },
					{ title: '发布商品', path: '/provider/product-publish', icon: 'additional' },
					{ title: '商品管理', path: '/provider/products', icon: 'package' },
					{ title: '订单管理', path: '/provider/orders', icon: 'order' },
					{ title: '配置管理', path: '/provider/configuration', icon: 'settings' }
				]
			}
		},
		computed: {
			...mapGetters(['isMerchantShopApproved']),
			/**
			 * 当前路由对应的侧边栏菜单路径。
			 * 通用匹配当前路由所属的最深层菜单，后续为任意菜单扩展子路由时无需增加路径特判。
			 */
			activeMenu() {
				// 获取完整的当前路由地址，用于同时匹配菜单本身及其下级页面。
				const currentPath = this.$route.path
				// 筛选当前路径所属的所有候选菜单，并优先选择路径最长、层级最深的菜单。
				const matchedMenu = this.menus
					.filter(item => currentPath === item.path || currentPath.startsWith(`${item.path}/`))
					.sort((menuA, menuB) => menuB.path.length - menuA.path.length)[0]
				// 未匹配到已配置菜单时返回当前路径，兼容后续新增的独立页面。
				return matchedMenu ? matchedMenu.path : currentPath
			},
			// 审核通过后隐藏申请入口并开放全部业务菜单；未通过时仅允许维护个人资料和提交/查看商家申请。
			visibleMenus() {
				if (this.isMerchantShopApproved) {
					return this.menus.filter(item => item.path !== '/provider/application')
				}
				return this.menus.filter(item => ['/provider/profile', '/provider/application'].includes(item.path))
			}
		},
		created() {
			// 刷新服务商端时主动加载店铺状态，菜单会随审核结果自动调整。
			this.$store.dispatch('merchantShop/loadShopContext')
		}
	}
</script>

<style lang="scss" scoped>
	.provider-layout {
		display: flex;
		flex-direction: column;
		height: 100vh;
		overflow: hidden;
		background: #f3f6fa;
	}

	.provider-body {
		display: flex;
		flex: 1;
		min-height: 0;
		padding: 20px 24px 24px;
	}

	.provider-sidebar {
		display: flex;
		flex: 0 0 218px;
		flex-direction: column;
		overflow: hidden;
		border: 1px solid #e4e9ef;
		border-radius: 8px;
		background: #ffffff;
		box-shadow: 0 5px 18px rgba(35, 64, 99, 0.05);
	}

	.sidebar-heading {
		display: flex;
		align-items: center;
		padding: 21px 18px;
		border-bottom: 1px solid #edf0f4;

		.heading-mark {
			display: flex;
			align-items: center;
			justify-content: center;
			width: 38px;
			height: 38px;
			margin-right: 11px;
			border-radius: 9px;
			color: #ffffff;
			font-size: 20px;
			background: linear-gradient(145deg, #3384df, #236fc9);
		}

		strong,
		small {
			display: block;
		}

		strong {
			color: #303846;
			font-size: 16px;
		}

		small {
			margin-top: 3px;
			color: #a1a8b2;
			font-size: 10px;
		}
	}

	.provider-menu {
		flex: 1;
		padding: 12px 10px;
		overflow-y: auto;
		border-right: none;

		::v-deep .el-menu-item {
			height: 48px;
			margin-bottom: 5px;
			padding: 0 15px !important;
			border-radius: 5px;
			color: #515d6c;
			font-size: 15px;
			line-height: 48px;
			transition: color 0.2s ease, background-color 0.2s ease;

			.svg-icon {
				width: 20px;
				height: 20px;
				margin-right: 11px;
				color: #8893a1;
				vertical-align: -4px;
			}

			&:hover {
				color: #2671cb;
				background: #edf5ff;

				.svg-icon {
					color: #2671cb;
				}
			}

			&.is-active {
				color: #ffffff;
				font-weight: 500;
				background: linear-gradient(90deg, #2878d3, #3f8be0);
				box-shadow: 0 5px 12px rgba(38, 113, 203, 0.18);

				.svg-icon {
					color: #ffffff;
				}
			}
		}
	}

	.provider-main {
		flex: 1;
		min-width: 0;
		margin-left: 20px;
		overflow-y: auto;
	}
</style>
